import { Component, inject } from "@angular/core";

import { AnbefalingCard } from "./components/anbefaling-card/anbefaling-card";
import { Oppsummering as OppsummeringModel } from "../../models/oppsummering.model";
import { FinnKommuneCard } from "./components/finn-kommune-card/finn-kommune-card";
import { ActivatedRoute, Router } from "@angular/router";
import { LagrePdfCard } from "./components/lagre-pdf-card/lagre-pdf-card";
import { OkonomiCard } from "./components/okonomi-card/okonomi-card";

@Component({
  selector: "bko-result",
  imports: [AnbefalingCard, FinnKommuneCard, LagrePdfCard, OkonomiCard],
  templateUrl: "./oppsummering.html",
  styleUrl: "./oppsummering.scss",
})
export class Oppsummering {
  private route = inject(ActivatedRoute);

  oppsummering: OppsummeringModel = this.route.snapshot.data.oppsummering;
  id: string = this.route.snapshot.params.id;

  constructor() {
  }


}
